// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors

/**
 * NPM tag to use when loading modules from unpkg.com
 * 'beta' on beta branch, 'latest' on prod branch
 * @note Change between 'beta' and 'latest' depending on whether publishing alpha or prod releases
 * @todo - unpkg.com doesn't seem to have a `latest` specifier for alpha releases...
 */
export const NPM_TAG = 'latest';
